import fetch from 'isomorphic-fetch'
import { getRootURL } from '../../../lib'
import { tokenSilentlyOption } from '../../../lib/Auth0'

export const paymentHistory = () => (dispatch, getState) => {
  const auth0 = getState().authentication.auth0
  if (!auth0) return
  return auth0.getTokenSilently(tokenSilentlyOption)
  .then(accessToken => {
		return fetch(getRootURL() + '/paypal/payment_history', {
			method: 'POST',
			headers: {
        "Content-Type": "application/json",
        Authorization: 'Bearer ' + accessToken
			}
		})
  })
  .then(response => response.json())
	.then(json => {
    return Promise.resolve(json)
  })
}


// WEBPACK FOOTER //
// ./src/Pages/Settings/actions/index.js